import cx from 'classnames';
import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const Hazard = forwardRef<SVGSVGElement, OwnProps>(
  ({ className, ...props }, ref) => (
    <svg
      viewBox="0 0 16 14"
      height={14}
      width={16}
      className={cx('-:fill-yellow-2', className)}
      ref={ref}
      {...props}
    >
      <path d="M15.7325 11.1058L9.65095 0.942308C9.29718 0.353365 8.67386 0 8 0C7.32614 0 6.70282 0.353365 6.34905 0.925481L0.267476 11.1058C-0.0862996 11.6947 -0.0862996 12.4183 0.25063 13.024C0.587559 13.6298 1.21088 14 1.91843 14H14.0816C14.7723 14 15.3956 13.6298 15.7494 13.024C16.0863 12.4183 16.0863 11.6947 15.7325 11.1058ZM7.22506 4.84615C7.22506 4.42548 7.57884 4.07212 8 4.07212C8.42116 4.07212 8.77494 4.42548 8.77494 4.84615V8.0601C8.77494 8.48077 8.42116 8.83414 8 8.83414C7.57884 8.83414 7.22506 8.48077 7.22506 8.0601V4.84615ZM8 11.5264C7.47776 11.5264 7.0566 11.1058 7.0566 10.5841C7.0566 10.0625 7.47776 9.64183 8 9.64183C8.52224 9.64183 8.9434 10.0625 8.9434 10.5841C8.9434 11.1058 8.52224 11.5264 8 11.5264Z" />
    </svg>
  )
);

export default Hazard;
